export default {
    methods:{
        clearQueryParams(){
          if(Object.keys(this.$route.query).length){
            this.$router.replace({'query': ''});
          }
        }
    }
}
